import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { servicePriceLabel } from "@/lib/constants";
import { ImageOff, MapPin, Globe, Wrench, Search } from "lucide-react";

export default function ServiceCard({ listing, categoryLabel }) {
  const img = listing.images?.[0];
  const isRequest = listing.service_type === "request";
  return (
    <Link
      to={`/services/${listing.id}`}
      data-testid={`service-card-${listing.id}`}
      className="group block"
    >
      <Card className="overflow-hidden border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/10">
        <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
          {img ? (
            <img src={img} alt={listing.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-muted-foreground">
              <ImageOff className="h-10 w-10" />
            </div>
          )}
          <Badge
            className={`absolute left-2 top-2 border-0 text-[10px] font-bold uppercase tracking-wide text-white ${isRequest ? "bg-amber-600" : "bg-primary"}`}
          >
            {isRequest ? (<><Search className="mr-1 h-3 w-3" /> Looking for</>) : (<><Wrench className="mr-1 h-3 w-3" /> Offering</>)}
          </Badge>
          {listing.remote_ok && (
            <span className="absolute right-2 top-2 flex items-center gap-1 rounded bg-black/60 px-2 py-0.5 text-[10px] font-semibold text-white">
              <Globe className="h-3 w-3" /> Remote
            </span>
          )}
        </div>
        <div className="p-3">
          <p className="truncate text-xs text-muted-foreground">
            {categoryLabel ? categoryLabel(listing.category) : listing.category} · {listing.seller_username}
          </p>
          <h3 className="mt-0.5 line-clamp-2 min-h-[2.5rem] font-medium leading-tight">{listing.title}</h3>
          <div className="mt-2 flex items-center justify-between">
            <span className="font-display text-base font-bold text-primary">
              {servicePriceLabel(listing)}
            </span>
            {listing.location && (
              <span className="flex items-center gap-1 text-xs text-muted-foreground">
                <MapPin className="h-3 w-3" />
                {listing.location}
              </span>
            )}
          </div>
        </div>
      </Card>
    </Link>
  );
}
